export default __webpack_public_path__ + "static/media/news072602.76c3d712.jpg";